import { firestore, db } from "../config/db"
import {
  getFirestore,
  collection,
  query,
  orderBy,
  getDocs,
  doc,
  updateDoc,
} from "firebase/firestore"

export const testButton = () => {
  try {
    firestore.collection("test").doc("document3").set({
      name: "Mark",
      age: 12,
    })
  } catch (error) {
    console.log(error)
  }
}

export const downloadCandidates = async () => {
  try {
    const submissionsRef = query(
      collection(db, "submissions"),
      orderBy("createdAt", "asc"),
    )

    const submissionsSnapshot = await getDocs(submissionsRef)

    let arr = []
    submissionsSnapshot.forEach((doc) => {
      let data = doc.data() // Get document data
      arr.push(data) // Push it to the array
    })

    return arr
  } catch (error) {
    console.log(error)
  }
}

export const fetchAdmins = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "users"))
    const userData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }))
    return userData
  } catch (error) {
    console.error("Error fetching users:", error)
  }
}

export const toggleAuthenticated = async (userId, currentStatus) => {
  try {
    const userDoc = doc(db, "users", userId)
    await updateDoc(userDoc, { authenticated: !currentStatus })
    return (prevUsers) =>
      prevUsers.map((user) =>
        user.id === userId ? { ...user, authenticated: !currentStatus } : user,
      )
  } catch (error) {
    console.error("Error updating authenticated status:", error)
  }
}
export const getRankedCandidates = async () => {
  try {
    const submissionsRef = collection(firestore, "submissions")
    const submissionsSnapshot = await getDocs(submissionsRef)

    const rankedCandidates = []

    for (const submissionDoc of submissionsSnapshot.docs) {
      const submissionData = submissionDoc.data()
      const uid = submissionDoc.id // Document ID in 'submissions'

      const ratingCollectionRef = collection(
        firestore,
        `submissions/${uid}/rating`,
      )
      const ratingSnapshot = await getDocs(ratingCollectionRef)

      let totalRating = 0
      let totalRatingNums = 0

      if (!ratingSnapshot.empty) {
        ratingSnapshot.forEach((ratingDoc) => {
          const ratingData = ratingDoc.data()
          console.log("Rating Doc:", ratingData)

          if (ratingData?.rating) {
            // Ensure rating field exists
            if (ratingData?.rating !== null) {
              totalRating += ratingData.rating
              totalRatingNums++
            }
          }
        })
      } else {
        console.warn(`No ratings found for UID: ${uid}`)
      }

      rankedCandidates.push({
        candidateId: uid,
        totalRating: totalRating,
        totalRatingNums: totalRatingNums,
        averageRating: totalRating / totalRatingNums,
        ...submissionData, // Include other submission data
      })
    }

    // Sort the candidates by total rating in descending order
    rankedCandidates.sort((a, b) => b.totalRating - a.totalRating)

    return rankedCandidates
  } catch (error) {
    console.error("Error fetching ranked candidates:", error)
  }
}
